import { Button, Modal, Tooltip } from "@material-ui/core";
import { Box, Typography } from "@mui/material";
import {
  ArrowsOut,
  CalendarCheck,
  CheckCircle,
  CheckSquareOffset,
  Warning,
} from "phosphor-react";
import React, { useEffect, useState } from "react";
import { fget } from "../../../../../API/callsAPI";
import commonStyles from "../../../../../Utils/commonStyles";
import DateAndTimeViewer from "../../../../Utilities/DateAndTimeViewer/DateAndTimeViewer.component";
import ChitranSvg from "../../../../Utilities/Svg/ChitranSvg";
import useStyles from "../../../../Utilities/TaskToDos/TaskToDos.styles";
import TodoExpandedViewModal from "../../WidgetsModals/TodoExpandedViewModal";
import Loader from "../../../../Utilities/Loader/Loader";
import { getElapsedTime } from "../../../../../Utils/getElapsedTime";

const SingleTodoComponent = ({ projectId }) => {
  const classes = useStyles();
  const commonClasses = commonStyles();
  const [isExpandedViewOpen, setIsExpandedViewOpen] = useState(false);
  const [isCheckListLoading, setIsCheckListLoading] = useState(true);
  const [checkList, setCheckList] = useState([]);

  const getChecklist = async (loader) => {
    setIsCheckListLoading(true);
    try {
      const res = await fget({
        url: `trackables/checklist/?project=${projectId}&completed=False&assigned=1`,
      });
      setCheckList(res.data.results);
      setIsCheckListLoading(false);
    } catch (error) {
      setIsCheckListLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (projectId) {
      getChecklist("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    <Box className={commonClasses.bigWidgetRoot}>
      <Box className={commonClasses.widgetTitleContainer}>
        <Box className={commonClasses?.flexAndGap8Px}>
          <CalendarCheck size={22} fill="#F5944E" color="#F5944E" />
          <Typography className={commonClasses.widgetsTitle}>
            My Todo's
          </Typography>
        </Box>
        <div className={commonClasses?.flexAndGap8Px}>
          {/* <PencilLine size={20} color="gray" /> */}
          {/* <Trash size={20} color="gray" /> */}
          <Button
            onClick={() => setIsExpandedViewOpen(true)}
            style={{ padding: 0 }}
          >
            <ArrowsOut size={20} />
          </Button>
        </div>
      </Box>
      <Box
        sx={{
          height: { md: "220px", lg: "280px", xl: "320px" },
          overflowY: "auto",
          marginTop: "12px",
          paddingRight: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {!isCheckListLoading ? (
          <>
            {checkList?.length ? (
              checkList?.map((singleTaskCheckList) =>
                singleTaskCheckList?.checklist_items?.map((checklist) => (
                  <Box
                    style={{
                      fontSize: "12px",
                      backgroundColor: "#1F222E",
                      padding: "6px 8px",
                      borderRadius: "5px",
                    }}
                  >
                    <div className={classes.spaceBetween}>
                      <Typography
                        sx={{
                          fontSize: {
                            md: "10px !important",
                            lg: "12px !important",
                            xl: "12px !important",
                          },
                        }}
                      >
                        {checklist?.title}
                      </Typography>
                    </div>
                    <div className={classes.spaceBetween}>
                      {checklist?.version_start || checklist?.version_end ? (
                        <div
                          className={`${classes.header} ${classes.versionName}`}
                        >
                          {checklist?.version_start && (
                            <>
                              <Warning size={18} weight="fill" />{" "}
                              <Tooltip title={checklist?.version_start?.name}>
                                <Typography
                                  sx={{
                                    maxWidth: checklist?.version_end
                                      ? "40%"
                                      : "100%",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    fontSize: {
                                      md: "12px !important",
                                      lg: "12px !important",
                                      xl: "14px !important",
                                    },
                                  }}
                                >
                                  {checklist?.version_start?.name}
                                </Typography>
                              </Tooltip>
                            </>
                          )}
                          {checklist?.version_end && (
                            <>
                              <CheckCircle
                                size={18}
                                weight="fill"
                                color="#44B927"
                              />
                              <Tooltip title={checklist?.version_end?.name}>
                                <Typography
                                  sx={{
                                    maxWidth: checklist?.version_start
                                      ? "40%"
                                      : "100%",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    color: "#44B927",
                                    fontSize: {
                                      md: "10px !important",
                                      lg: "10px !important",
                                      xl: "12px !important",
                                    },
                                  }}
                                >
                                  {checklist?.version_end?.name}
                                </Typography>
                              </Tooltip>
                            </>
                          )}
                        </div>
                      ) : (
                        <div
                          className={`${classes.header} ${classes.versionName}`}
                        >
                          <CheckSquareOffset size={18} weight="fill" />
                          <Typography>
                            {singleTaskCheckList?.task?.name}
                          </Typography>
                        </div>
                      )}
                      <Typography className={classes.tertiaryColor}>
                        {getElapsedTime(checklist?.created_at)}
                        {/* <DateAndTimeViewer
                          dateAndTime={checklist?.created_at}
                        /> */}
                      </Typography>
                    </div>
                  </Box>
                ))
              )
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <ChitranSvg height={170} width={180} />
                <Typography>You have no To-Do’s at the moment!</Typography>
              </Box>
            )}
          </>
        ) : (
          <Loader />
        )}
      </Box>
      <Modal
        open={isExpandedViewOpen}
        onClose={() => setIsExpandedViewOpen(false)}
        className={commonClasses?.flexCenter}
      >
        <TodoExpandedViewModal
          handleClose={() => setIsExpandedViewOpen(false)}
          projectId={projectId}
          isDelayedTask={false}
          delayedFilter=""
        />
      </Modal>
    </Box>
  );
};

export default SingleTodoComponent;
